<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="vid"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :class="{ 'placeholder-label': label === false }"
            :invalid-feedback="errors[0]"
            :label="label ? (label + (rules && rules.required ? ' *' : '')) : null"
            :state="rules ? (validated ? valid : null) : null"
        >            
            <rkm-input-group
                :append="append"
                :prepend="prepend"
            >
                <template
                    v-if="!prepend && $slots.prepend"
                    slot="prepend"
                >
                    <slot name="prepend" />
                </template>

                <b-form-input
                    :autocomplete="autocomplete"
                    :disabled="disabled"
                    :id="uniqueId"
                    :max="(rules && rules.max) || ''"
                    :maxlength="(rules && rules.max) || ''"
                    :min="(rules && rules.min) || ''"
                    :placeholder="placeholder"
                    :readonly="readonly"
                    :size="size"
                    :state="rules ? (validated ? valid ? null : false : null) : null"
                    :type="type"
                    :value="value"
                    @blur="$emit('blur', $event)"
                    @change="$emit('change', $event)"
                    @click="$emit('click', $event)"
                    @input="$emit('input', $event)"
                    @keydown.stop="$emit('keydown', $event)"
                    @submit="$emit('submit', $event)"
                    @update="$emit('update', $event)"
                    v-rkm-alpha="alpha"
                    v-rkm-number="number"
                    v-rkm-trim="trim"
                    v-rkm-uppercase="uppercase"
                />

                <template
                    v-if="!append && $slots.append"
                    slot="append"
                >
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
// Components.
import {BFormInput} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate'

// Mixins.
import {string} from './../mixins'

export default {
    components: {BFormInput, ValidationProvider},
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
    },
    mixins: [string],
    props: {
        alpha: {type: Boolean},
        append: {type: String},
        autocomplete: {type: String, default: 'off'},
        disabled: {type: Boolean},
        label: {type: [String, Boolean], default: ''},
        large: { type: Boolean },
        name: {type: String},
        number: {type: Boolean},
        placeholder: {type: String},
        prepend: {type: String},
        readonly: {type: Boolean},
        small: { type: Boolean },
        trim: {type: Boolean, default: true},
        type: {type: String, default: 'text'},
        uppercase: {type: Boolean},
        validationMode: {type: String, default: 'aggressive'},
        validations: {type: Object},
        value: {type: [Date, Number, String]},
        vid: {type: String},
    },
}
</script>